import '@reikraft/ui/fonts.css';
import '@reikraft/ui/styles.css';
import './admin.css';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter, Navigate } from 'react-router';
import { RouterProvider } from 'react-router/dom';
import { ToastProvider } from '@reikraft/ui';
import { ApiError } from './api';
import { Shell } from './Shell';
import { LoginPage } from './pages/Login';
import { OrdersPage } from './pages/Orders';
import { OrderNewPage } from './pages/OrderNew';
import { OrderPage } from './order/OrderPage';
import { IntakePage } from './pages/Intake';
import { StockPage } from './pages/Stock';
import { ProductPage } from './pages/Product';
import { UnitPage } from './pages/Unit';
import { ClientsPage, CustomerPage } from './pages/Clients';
import { OrganizationPage, OrganizationsPage } from './pages/Organizations';
import { MastersPage } from './pages/Masters';
import { PartsPage } from './pages/Parts';
import { FinancePage } from './pages/Finance';
import { SettingsPage } from './pages/Settings';
import { NotFoundPage } from './pages/NotFound';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 15_000,
      refetchOnWindowFocus: true,
      retry: (count, e) => !(e instanceof ApiError && e.status < 500) && count < 2,
    },
  },
});

const router = createBrowserRouter([
  { path: '/login', element: <LoginPage /> },
  {
    element: <Shell />,
    children: [
      { index: true, element: <Navigate to="/orders" replace /> },
      { path: 'orders', element: <OrdersPage /> },
      { path: 'orders/new', element: <OrderNewPage /> },
      { path: 'orders/:id', element: <OrderPage /> },
      { path: 'intake', element: <IntakePage /> },
      { path: 'stock', element: <StockPage /> },
      { path: 'stock/new', element: <ProductPage /> },
      { path: 'stock/:id', element: <ProductPage /> },
      { path: 'u/:code', element: <UnitPage /> },
      { path: 'units/:unitId', element: <UnitPage /> },
      { path: 'clients', element: <ClientsPage /> },
      { path: 'clients/:id', element: <CustomerPage /> },
      { path: 'organizations', element: <OrganizationsPage /> },
      { path: 'organizations/:id', element: <OrganizationPage /> },
      { path: 'masters', element: <MastersPage /> },
      { path: 'parts', element: <PartsPage /> },
      { path: 'finance', element: <FinancePage /> },
      { path: 'settings', element: <SettingsPage /> },
      { path: '*', element: <NotFoundPage /> },
    ],
  },
]);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <RouterProvider router={router} />
      </ToastProvider>
    </QueryClientProvider>
  </StrictMode>,
);
